import { commonapi } from "./commonAPI";
// user Login
export const userLoginApi = async (user) => {
  return await commonapi("POST", `${process.env.REACT_APP_USER_ROLE_BASEURL}/userLogin`, user, "");
};

// Module1: user and role permissions
export const userRoleCreationApi = async (reqBody) => {
  //Create Role
  return await commonapi(
    "POST",
    `${process.env.REACT_APP_USER_ROLE_BASEURL}/roleCreation`,
    reqBody
  );
};
export const getAllUserRoles = async (page, limit) => {
  const queryParams = `?page=${page}&limit=${limit}`;
  return await commonapi(
    "GET",
    `${process.env.REACT_APP_USER_ROLE_BASEURL}/getAllUserRoles${queryParams}`,
    "",
    ""
  ); //Index Role
};
export const editUserRole = async (reqBody) => {
  return await commonapi("PUT", `${process.env.REACT_APP_USER_ROLE_BASEURL}/updaterole`, reqBody); //Update Role
};
export const deleteUserRole = async (id) => {
  return await commonapi("DELETE", `${process.env.REACT_APP_USER_ROLE_BASEURL}/deleterole/${id}`); //Delete Role
};

export const getAllUserRolesbyId = async (roleId) => {
  return await commonapi(
    "GET",
    `${process.env.REACT_APP_USER_ROLE_BASEURL}/getAllUserRoles/${roleId}`,
    "",
    ""
  );
};

export const userCreationApi = async (reqBody, reqHeader) => {
  //Create User
  return await commonapi(
    "POST",
    `${process.env.REACT_APP_USER_ROLE_BASEURL}/userCreation`,
    reqBody,
    reqHeader
  );
};

export const updateUser = async (userId, reqBody) => {
  return await commonapi(
    "PUT",
    `${process.env.REACT_APP_USER_ROLE_BASEURL}/updateuser/${userId}`,
    reqBody
  ); //Update Role
};

export const deleteUser = async (id) => {
  return await commonapi("DELETE", `${process.env.REACT_APP_USER_ROLE_BASEURL}/deleteUser/${id}`); //Delete Role
};

export const getAllUsers = async (page, limit, searchQuery = "", reqHeader) => {
  // Index User
  const queryParams = `?page=${page}&limit=${limit}&search=${encodeURIComponent(searchQuery)}`;
  return await commonapi(
    "GET",
    `${process.env.REACT_APP_USER_ROLE_BASEURL}/getallusers${queryParams}`,
    null,
    reqHeader
  );
};

export const getUserById = async (id) => {
  return await commonapi("GET", `${process.env.REACT_APP_USER_ROLE_BASEURL}/getuser/${id}`, "", "");
};

export const getAllPermissions = async () => {
  return await commonapi(
    "GET",
    `${process.env.REACT_APP_USER_ROLE_BASEURL}/getallpermissions`,
    "",
    ""
  );
};

export const getRolehasPermissions = async (id) => {
  return await commonapi(
    "GET",
    `${process.env.REACT_APP_USER_ROLE_BASEURL}/getPermissionByRole/${id}`,
    "",
    ""
  );
};
